import { jsx as _jsx } from "react/jsx-runtime";
import BaseFieldDetail from "../base/detail";
import { FieldViewType } from "../viewType";
/** <b>Composant en mode consultation/detail d'un champ de type link</b>*/
export default function LinkFieldList(_a) {
    var record = _a.record, fieldName = _a.fieldName, fieldMetadata = _a.fieldMetadata;
    return (_jsx(BaseFieldDetail, { viewType: FieldViewType.DETAIL, fieldName: fieldName, record: record, link: fieldName && record[fieldName], target: (fieldMetadata && fieldMetadata.link_target) || "_self" }));
}
